import CityPageTemplate from "../city-template/CityPageTemplate";
import { caryConfig } from "./data";

export default function CaryPage() {
  return <CityPageTemplate config={caryConfig} />;
}